// Only the background is marked, never the text colour, so a veld keeps the styling of its version.
export function gewijzigdMarkering(isGewijzigd: boolean, variant: "veld" | "toelichting" = "veld"): string | undefined {
    if (!isGewijzigd) {
        return undefined;
    }
    return variant === "veld" ? "bg-accent-yellow-subtle font-medium" : "bg-accent-yellow-subtle";
}
